import { createAction, TypeConstant, createStandardAction, ActionType } from 'typesafe-actions';
import { Page } from 'src/Models';
import uuid from 'uuid/v4';

export interface MetaType {
  date: Date;
  syncedAt?: Date;
  needSync: boolean;
  id: string;
}

const createAuditAction = <T extends TypeConstant>(type: T, defaultMeta?: Partial<MetaType>) => {
  return <P>() => {
    return createAction(type, action => {
      return (payload: P, meta?: Partial<MetaType>) =>
        action(payload, {
          date: new Date(),
          needSync: (meta && meta.needSync) || false,
          ...defaultMeta,
          id: uuid(),
        } as MetaType);
    });
  };
};

const onPageCreated = createAuditAction('@Audit/OnPageCreated', { needSync: true })<Page>();
const onPageUpdated = createAuditAction('@Audit/OnPageUpdated', { needSync: true })<Page>();
const onPageDeleted = createAuditAction('@Audit/onPageDeleted', { needSync: true })<Page>();

export type SyncAction = ActionType<typeof syncActions>;

export const syncActions = {
  onPageCreated,
  onPageUpdated,
  onPageDeleted,
};

const markLogAsSynced = createStandardAction('@Audit/markAsSynced')<string>();
const startAppSync = createStandardAction('APP_SYNC_START')();
const appSyncSuccess = createStandardAction('APP_SYNC_SUCCESS')();
const appSyncError = createStandardAction('APP_SYNC_ERROR')<any>();

export const controlActions = {
  markLogAsSynced,
  startAppSync,
  appSyncSuccess,
  appSyncError,
};



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/AuditLog/actions.ts